import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_CONSERVATION_FILES_PATH,
  GetConservationFilesErrorDto,
  GetConservationFilesSuccessDto,
} from '@/api/rest/resources/conservation';

type SuccessDto = GetConservationFilesSuccessDto;
type ErrorDto = GetConservationFilesErrorDto;

export const useConservation = (projectName: string) => {
  const pathParams = {
    project_name: projectName,
  };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_CONSERVATION_FILES_PATH, pathParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['conservation', 'organization', pathParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const useConservationFile = <
  T extends
    GetConservationFilesSuccessDto[keyof GetConservationFilesSuccessDto] = GetConservationFilesSuccessDto[keyof GetConservationFilesSuccessDto],
>({
  projectName,
  fileName,
}: {
  projectName: string;
  fileName: keyof GetConservationFilesSuccessDto;
}): T | null => {
  const { data } = useConservation(projectName);
  return data ? (data[`${fileName}`] as T) : null;
};
